export default "__VITE_ASSET__d19fa5df__"